/*
 * Project: bellcloud
 * File: apps/frontend/src/features/guide/guideStorage.ts
 * Description: 가이드 완료 상태 저장 (localStorage). 첫 방문 자동 실행 확장에 사용.
 */

/** localStorage 키 prefix — 예: bellcloud.guide.completed.register */
const STORAGE_PREFIX = 'bellcloud.guide.completed';

function storageKey(guideKey: string): string {
  return `${STORAGE_PREFIX}.${guideKey}`;
}

/** 해당 가이드를 이미 완료했는지 여부 */
export function hasCompletedGuide(guideKey: string): boolean {
  try {
    return localStorage.getItem(storageKey(guideKey)) === 'true';
  } catch {
    // 시크릿 모드 / 저장소 차단 환경 — 자동 실행만 비활성화되며 앱은 정상 동작
    return false;
  }
}

/** 가이드 완료 상태 저장 */
export function markGuideCompleted(guideKey: string): void {
  try {
    localStorage.setItem(storageKey(guideKey), 'true');
  } catch {
    // 저장 실패는 무시 (저장소 차단 환경)
  }
}

/** 가이드 완료 상태 초기화 (재실행/테스트용) */
export function resetGuide(guideKey: string): void {
  try {
    localStorage.removeItem(storageKey(guideKey));
  } catch {
    // 무시
  }
}
